import React from 'react';

import classnames from 'classnames';

import './styles';

export default class Checkbox extends React.Component {
  onClick() {
    if (this.props.onChange) {
      this.props.onChange(this.props.type === 'radio' || !this.props.checked);
    }
  }

  render() {
    return (
      <div className={classnames('Checkbox', 'ui', this.props.className, 'checkbox')} ref="checkbox" onClick={this.onClick.bind(this)}>
        {(() => {
          if (this.props.type === 'radio') {
            return <i className={classnames('radio', {selected: this.props.checked}, this.props.iconSize, 'icon')} />;
          }
        })()}
        <input type={this.props.type || 'checkbox'} name={this.props.name} checked={this.props.checked} onChange={() => {}} key={this.props.checked} />
        <label>{this.props.label}</label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/sp-components/components/Checkbox/index.jsx